<template>
  <nav class="flex-grow-0">
    <div class="logo-wrapper">
      <span id="logo" class="logo-wordmark">FlexTLFB</span>
    </div>
    <div class="popover-wrapper" v-if="user">
      <Popover v-model:showPopover="showUserPopover">
        <template v-slot:toggle>
          <div class="user-content-wrapper">
            <p class="name">{{ user.firstName }}</p>
            <UserIcon />
          </div>
        </template>
        <template v-slot:content>
          <div @mouseleave="showUserPopover = false" class="dropdown-content">
            <div
              v-if="user.isAdmin"
              @click="handleManageUsers"
              class="popover-option"
            >
              <span>Manage Users</span>
            </div>
            <div @click="handleSignout" class="popover-option">
              <span>Sign Out</span>
            </div>
          </div>
        </template>
      </Popover>
    </div>
  </nav>
  <ManageUsersModal
    v-if="showUserManagementModal"
    @close-modal="showUserManagementModal = false"
    :user="user"
  />
</template>

<script setup>
import { ref, watch } from "vue"
import { useRoute } from "vue-router"
import logout from "../services/logout"
import ManageUsersModal from "./ManageUsersModal.vue"
import Popover from "./Popover.vue"
import UserIcon from "./UserIcon.vue"

defineProps({
  user: [Object, null]
})

const showUserPopover = ref(false)
const showUserManagementModal = ref(false)

async function handleSignout() {
  showUserPopover.value = false
  await logout()
}

async function handleManageUsers() {
  showUserManagementModal.value = true
  showUserPopover.value = false
}

const route = useRoute()
watch(route, () => {
  setTimeout(() => {
    showUserPopover.value = false
  }, 300)
})
</script>

<style scoped>
nav {
  box-shadow: rgba(0, 0, 0, 0.24) 0px 2px 6px;
  justify-content: space-between;
  align-items: center;
  max-height: 80px;
  padding: 0.5rem;
  height: 5.3rem;
  display: flex;
  z-index: 1000;
}

.logo-wordmark {
  margin-top: 0.5rem;
  font-size: 1.75rem;
  font-weight: 800;
  color: maroon;
  letter-spacing: -0.02em;
  line-height: 1;
}

.popover-option {
  border-radius: 0.2em;
  margin-bottom: 0.2em;
  margin-top: 0.2em;
  cursor: pointer;
  padding: 0.33em;
}
.popover-option:hover {
  background-color: rgb(244, 244, 244);
  color: maroon;
}

.dropdown {
  overflow: hidden;
  /* color: maroon */
}

.user-icon {
  height: 10%;
  width: 10%;
}

.dropdown .dropbtn {
  background-color: transparent;
  border-top-right-radius: 7px;
  border-top-left-radius: 7px;
  padding: 0.4rem 1rem;
  font-family: inherit;
  margin-top: 0.4rem;
  font-weight: bold;
  overflow: hidden;
  margin-top: 0rem;
  font-size: 22px;
  float: center;
  outline: none;
  border: none;
  margin: 0;
}

.dropdown-content button {
  font-family: inherit;
  padding: 8px 4px;
  font-size: 18px;
  color: white;
}

.navbar button:hover,
.dropdown:hover .dropbtn {
  background-color: maroon;
  color: white;
}

.dropdown-content {
  border-radius: 7px;
  min-width: 120px;
  z-index: 1000;
}

.dropdown-content button:hover {
  text-decoration: underline;
  font-weight: bold;
}

.dropdown:hover .dropdown-content {
  display: block;
}

.user-content-wrapper {
  justify-content: flex-start;
  align-items: center;
  display: flex;
  flex-grow: 0;
}

.user-content-wrapper > * {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}

.name {
  font-size: 1.5em;
  font-weight: bold;
  margin: 0;
}

.popover-wrapper {
  margin-right: 2em;
}
</style>
